import React from "react";
import {
  Box,
  Typography,
  List,
  ListItem,
  ListItemSecondaryAction,
  IconButton,
  TextField,
} from "@mui/material";
import { Add as AddIcon, Delete as DeleteIcon } from "@mui/icons-material";
import { EvacuationFormStep } from "../../types/evacuation";

interface EditableEvacuationStepsListProps {
  steps: EvacuationFormStep[];
  onAddStep: () => void;
  onRemoveStep: (stepId: string | number) => void;
  onUpdateStep: (stepId: string | number, description: string) => void;
}

export const EditableEvacuationStepsList: React.FC<EditableEvacuationStepsListProps> = ({
  steps,
  onAddStep,
  onRemoveStep,
  onUpdateStep,
}) => {
  return (
    <Box>
      <Box
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          mb: 2,
        }}
      >
        <Typography variant="h6">Steg i checklistan</Typography>
        <IconButton onClick={onAddStep} color="primary">
          <AddIcon />
        </IconButton>
      </Box>

      <List>
        {steps.map((step) => (
          <ListItem
            key={step.id}
            sx={{ border: "1px solid #e0e0e0", mb: 1, borderRadius: 1 }}
          >
            <Box sx={{ flexGrow: 1, mr: 2 }}>
              <Typography variant="subtitle2" sx={{ mb: 1 }}>
                Steg {step.order}
              </Typography>
              <TextField
                fullWidth
                multiline
                rows={2}
                placeholder="Beskriv steget..."
                value={step.description}
                onChange={(e) => onUpdateStep(step.id, e.target.value)}
                variant="outlined"
                size="small"
              />
            </Box>
            <ListItemSecondaryAction>
              {steps.length > 1 && (
                <IconButton
                  edge="end"
                  onClick={() => onRemoveStep(step.id)}
                  color="error"
                >
                  <DeleteIcon />
                </IconButton>
              )}
            </ListItemSecondaryAction>
          </ListItem>
        ))}
      </List>
    </Box>
  );
};
